import { useMemo } from 'react';
import { compareMemosByDate } from 'utils/memoDateUtils';

/**
 * Hook to get sorted memos with streaming updates applied
 * @param {Array} memos - The memos to sort
 * @param {Object} streamConfig - Streaming configuration
 * @param {string} streamData - Streaming data
 * @returns {Array} Sorted and updated memos
 */
export function useSortedMemos(memos, streamConfig, streamData) {
  const sortedMemos = useMemo(() => {
    return memos ? [...memos].sort(compareMemosByDate) : [];
  }, [memos]);

  // Apply streaming updates to sorted memos
  const memosWithStream = useMemo(() => {
    let allMemos = [...sortedMemos];
    
    // Handle streaming memo updates
    if (streamConfig?.memo_id && streamData) {
      const memoIndex = allMemos.findIndex(memo => memo.id === streamConfig.memo_id);
      if (memoIndex > -1) {
        allMemos[memoIndex] = { ...allMemos[memoIndex], text: streamData };
      }
    }
    
    return allMemos;
  }, [sortedMemos, streamConfig, streamData]);

  return memosWithStream;
}